import { getSVG } from './components/icons-loader.js';
import { showMoreFaqs, accordion } from './components/accordion.js';
import { enableSearch, enableUserInteractionWithSamples } from './components/search.js';

document.addEventListener("DOMContentLoaded", function () {
  accordion('.faqs-cards');
  showMoreFaqs();
  getSVG();
  enableSearch();
  enableUserInteractionWithSamples();
  enableSearch();
});



